import { render } from "./OpenStreetMapsForm.vue?vue&type=template&id=61cf1a52"
import script from "./OpenStreetMapsForm.vue?vue&type=script&lang=js"
export * from "./OpenStreetMapsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.35_vue@3.4.35_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__